import { render, staticRenderFns } from "./otherContractList.vue?vue&type=template&id=2c63ba02&scoped=true"
import script from "./otherContractList.vue?vue&type=script&lang=js"
export * from "./otherContractList.vue?vue&type=script&lang=js"
import style0 from "./otherContractList.vue?vue&type=style&index=0&id=2c63ba02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c63ba02",
  null
  
)

export default component.exports